<template>
    <div class="row w-100">
        <div class="col-md-12 mb-3 w-100">

            <select ref="input" id="country" auto_fill="country" name="country_code" placeholder="Select Country"
                    class="form-control form-control-lg input-new-design-customer-attribute">
            </select>
            <span class="text text-danger error-label">{{ validationErrors.countries }}</span>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {getCustomerCountries} from '@/modules/common/api'

export default {
    name: "SelectCountries",
    props: ["validationErrors","countryName","countryCode"],
    data() {
        return {
            select: null,
            localCountries:[],
        }
    },
    mounted() {
        getCustomerCountries()
            .then(response => {
                this.localCountries = response.data
                this.initiateDropdown(this.localCountries)
                this.listenToTomSelectEvents()
            })
            .catch(error => {
                console.log(error)
            })
    },
    methods: {
        initiateDropdown() {
            let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.select = window.countriesSelect = new TomSelect(this.$refs['input'], {
                    preload: true,
                    labelField: 'countryName',
                    searchField: ['countryName'],
                    valueField: 'countryCode',
                    highlight: false,
                    persist: false,
                    load: function (query, callback) {
                        let self = this;

                        if (self.loading > 1) {
                            callback();
                            return;
                        }
                        callback(vm.localCountries)
                        self.settings.load = null;
                    },

                    render: {
                        option: function (item, escape) {
                            return `<div class="col-12 customerList_mobile">
                            ${item.countryName}
                       </div>`;
                        },
                        item: function (data, escape) {
                            return `<div class="col-12 customerList_mobile" style="display: flex; flex-direction: row; justify-content: space-between; width: 100% !important;">
                            ${data.countryName}
                            <svg style="cursor: pointer;margin-right:10px;" onclick="countriesSelect.clear()" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z" fill="#03A9F4"></path></svg>
                        </div>`;
                        },
                    },
                })

                this.select.on('load', (value, item) => {
                    let selected_country = value[13].countryCode;
                    if (this.countryCode) {
                        selected_country = this.countryCode
                    }
                    this.searchResult = this.localCountries.find(country => country.countryCode === selected_country);
                    EventBus.$emit('onCountryChanged', this.searchResult.countryCode)
                    EventBus.$emit('onCountrySelected', this.searchResult.timezone)
                    this.select.addItem(selected_country);
                })

                this.select.on('item_add', (value, item) => {
                    // document.getElementById("timezone-ts-control").setAttribute('readonly', true);
                    this.searchResult = this.localCountries.find(country => country.countryCode === value);
                    EventBus.$emit('onCountryChanged', this.searchResult.countryCode)
                    EventBus.$emit('onCountrySelected', this.searchResult.timezone)
                })
                this.select.on('item_remove', (value, item) => {
                    EventBus.$emit('onCountryChanged', null);
                })

            })
        },
        listenToTomSelectEvents() {
            try {

                this.select.on('item_add', (value, item) => {
                    this.searchResult = this.localCountries.find(country => country.countryCode === value);
                    EventBus.$emit('onCountryChanged', this.searchResult.countryCode)
                    EventBus.$emit('onCountrySelected', this.searchResult.timezone)
                })
            } catch (e) {
                console.warn(e.message)
            }

        }
    },
    watch: {
        countryCode(val) {
            (val && this.select) ? this.select.addItem(val) : '';
        }
    }
}
</script>

<style scoped>

</style>